var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.049 8.577c.727 3.887 5.364 5.871 7.59 6.377-.607-2.125.608-3.036 2.126-3.036 1.519 0 7.289.303 9.718 2.43 1.944 1.7 1.215 3.542.607 4.25 1.216.102 4.374.122 7.29-.607 3.644-.91 3.34-4.858 0-6.983l-.13-.082C24.93 8.81 20.734 6.14 16.537 5.54 12.285 4.933.138 3.718 1.05 8.577z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.055 2.2c-3.159-.729-5.568.709-6.378 1.518 1.114 0 3.827.122 5.77.608 1.944.486 4.454 1.417 5.466 1.822-.303-1.012-1.7-3.22-4.858-3.948z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.159 14.347-6.075 11.54c4.616 4.616 11.844 4.353 14.88 3.644l1.519-12.146c0-.81-.911-2.612-4.555-3.34-3.645-.73-5.366-.102-5.771.303z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfo);
export default __webpack_public_path__ + "static/media/UFO.ab57b9e22c343e099a86979e0825a9ea.svg";
export { ForwardRef as ReactComponent };